/**
 * @generated SignedSource<<92c9c3e3e6300d4142766d6f578df8ad>>
 * @relayHash 8d5ccfda51f35629fafee028da3d804a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90fbdf755628844ce413889f0f639d072a3046f9e46c2766b494a79d039a949b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SandboxEchoPageQuery$variables = {
  cloudId: string;
  enableDefer: boolean;
};
export type SandboxEchoPageQuery$data = {
  readonly jira: {
    readonly criticalMessage: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"SandboxEchoDefer1" | "SandboxEchoDefer2" | "SandboxEchoDefer3">;
  };
};
export type SandboxEchoPageQuery = {
  response: SandboxEchoPageQuery$data;
  variables: SandboxEchoPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enableDefer"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": "criticalMessage",
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "echo"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SandboxEchoPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "SandboxEchoDefer1"
                }
              ]
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "SandboxEchoDefer2"
                }
              ]
            },
            {
              "kind": "Defer",
              "selections": [
                {
                  "args": [
                    (v1/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "enableDefer",
                      "variableName": "enableDefer"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "SandboxEchoDefer3"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SandboxEchoPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer1_PVNZy",
            "selections": [
              {
                "alias": "defer1",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "delayMs": 500
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "echo"
              }
            ]
          },
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer2_PVNZy",
            "selections": [
              {
                "alias": "defer2",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "delayMs": 700
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "echo"
              }
            ]
          },
          {
            "if": "enableDefer",
            "kind": "Defer",
            "label": "SandboxEchoPageQuery$defer$SandboxEchoDefer3_1jcU60",
            "selections": [
              {
                "alias": "defer3",
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "delayMs": 900
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "echo"
              },
              {
                "if": "enableDefer",
                "kind": "Defer",
                "label": "SandboxEchoDefer3$defer$SandboxEchoNestedDefer_PVNZy",
                "selections": [
                  {
                    "alias": "nestedImmediate",
                    "args": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "delayMs": 1
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "echo"
                  },
                  {
                    "alias": "nestedDefer1",
                    "args": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "delayMs": 600
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "echo"
                  },
                  {
                    "alias": "nestedDefer2",
                    "args": [
                      (v1/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "where",
                        "value": {
                          "delayMs": 1600
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "echo"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "90fbdf755628844ce413889f0f639d072a3046f9e46c2766b494a79d039a949b",
    "metadata": {},
    "name": "SandboxEchoPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "07f18ccbf2f419401bd051440180e2b1";

export default node;
